export default __webpack_public_path__ + "b572a74d1eaf8ef5bf49d45632ce4638.png";